import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import { Alert } from "components/base/Toast";
import { GTM_PROJECT_SAVE_PACKAGING } from "./graphql";
import { useEffect, useState } from "react";
import { useRef } from "react";

const useSavePackaging = (packagingId, dataKey, initialState) => {
  const [state, setState] = useState(initialState || {});
  const [savePackaging, { loading }] = useMutation(GTM_PROJECT_SAVE_PACKAGING, {
    onCompleted() {
      Alert("success", "Packaging updated.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  const timer = useRef(null);

  function onChange(key, value, debounceSave = true, timeout = 1000) {
    const newValue = { ...state, [key]: value };
    setState(newValue);
    if (debounceSave) {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => save(newValue), timeout);
    } else {
      save(newValue);
    }
  }

  function save(newValue) {
    savePackaging({
      variables: {
        packagingId,
        [dataKey]: JSON.stringify(newValue, " ", 2),
      },
    });
  }

  useEffect(() => {
    () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return { state, onChange, loading };
};

export default useSavePackaging;
